import ReactSlider from 'react-slider';
import classNames from "classnames";
import suitcaseDollarSign from '../../assets/images/suitcase-dollar-sign.png';
import dollarGreen from "../../assets/images/dollar-green.png";
import styles from "./FormTipInput.module.css";
import FormError from "./FormError";

const FormTipInput = (props) => {

    return (
        <div className={classNames(styles.container, props.className)} style={props.style}>
            <div className={styles.label}>
                Leave A Little Extra
            </div>
            <div className={styles.description}>
                Add a little extra to cover processing fees to make my gift go further and to keep Giverist free for charitable organizations.
            </div>
            {
                props.view === 'slider' && (
                    <div className={styles.sliderContainer}>
                        <ReactSlider className={styles.slider} value={props.tipPercent} min={0} max={50} step={0.5} onChange={(newValue) => props.updatePercent(newValue)}
                                     renderTrack={(properties, state) => (
                                        <div className={state.index === 1 ? styles.sliderTrack : ''}/>
                                     )}
                                     renderThumb={(properties) => {
                                         properties = {...properties, className: styles.sliderThumbContainer}
                                         return <div {...properties}>
                                                    <div className={styles.sliderThumbBubble}>
                                                        {props.tipPercent}%
                                                    </div>
                                                    <div className={styles.sliderThumb}/>
                                                </div>
                                     }}/>
                        <div className={styles.customTipContainer} onClick={() => props.setView('input')}>
                            <img className={styles.suitcaseDollarSign} src={suitcaseDollarSign} alt="Suitcase Dollar Sign"/>
                            <span className={styles.customTipText}>
                                Enter Custom Amount
                            </span>
                        </div>
                    </div>
                )
            }
            {
                props.view === 'input' && (
                    <div>
                        <div className={styles.inputContainer}>
                            <input className={styles.input} type="number" pattern="\d*" min="0" max="1000" step="0.01" placeholder="Enter tip amount"
                                   value={props.tipAmount} onChange={(newValue) => props.updateAmount(newValue)}/>
                            <img className={styles.dollarGreen} src={dollarGreen} alt="Money"/>
                            {
                                props.error && (
                                    <FormError error={props.error}/>
                                )
                            }
                        </div>
                        <div className={styles.cancelText} onClick={() => props.setView('slider')}>
                            Cancel
                        </div>
                    </div>
                )
            }
        </div>
    )
};

export default FormTipInput;